
const ListItem = ({ car, selectedMake, selectedFam, onClick }) => {
    if (!car || !car.rbc) { return null; }
    return (
        <div className="rb-list__item" onClick={() => { onClick(car.rbc); }}>
            <p><b>{car.make || selectedMake?.label} {car.family || selectedFam?.label || car.familycode} {car.year}</b></p>
            <p>{car.description}</p>
            <span />
        </div>
    );
}

export default ListItem;
